import { useEffect, useState } from 'react';

const usePredictiveText = () => {
    const [predictiveText, setPredictiveText] = useState([]);

    useEffect(() => {
        const fetchPredictiveText = async () => {
            try {
                const language = process.env.REACT_APP_LANGUAGE || 'es';
                const response = await fetch(`/locales/${language}/autocomplete.json`);
                const data = await response.json();
                setPredictiveText(data.predictive_text);
            } catch (error) {
                console.error('Error fetching predictive text:', error);
            }
        };

        fetchPredictiveText();
    }, []);

    return predictiveText;
};

export default usePredictiveText;